import React, { useState, useEffect } from "react";
import { NetworkManager } from "../../Components/NetworkManager";
import { CommonUtil } from "../../utils/CommonUtil";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import InstagramAccess from "./InstagramAccess";
import FbAndInstaAccess from "./FbAndInstaAccess";
import FacebookAccess from "./FacebookAccess";
interface FacebookManageProps {}

const ExistingFBPages: React.FC<FacebookManageProps> = () => {
  const [pagesData, setPagesData] = useState<any[]>([]);
  const [, setPagesCount] = useState<number>(0);
  const [selectedTab, setSelectedTab] = useState<string>("nav-fb-tab");

  useEffect(() => {
    localStorage.setItem("selectedConnection", selectedTab);
    localStorage.setItem("activeConnection", selectedTab);
  }, [selectedTab]);

  const ontabChange = (e: any) => {
    setSelectedTab(e.target.id);
  };

  useEffect(() => {
    NetworkManager.sendJsonRequest(
      "api/account/accessExistingPages",
      "",
      "",
      "GET",
      true,
      onSuccessCall,
      onErrorCall
    );
  }, []);

  const onSuccessCall = (data: any) => {
    var respData = CommonUtil.parseData(data);
    let connectedFbList = respData.connectedList;
    if (connectedFbList) {
      setPagesData(connectedFbList);
      setPagesCount(connectedFbList && connectedFbList.length);
    }
  };

  const onErrorCall = (err: any) => {};

  const fbPages = pagesData.filter(
    (fb: any) => fb["facebook"] && Object.keys(fb)?.length === 1
  );
  const fbPagesCount = fbPages.length;
  const instaPages = pagesData.filter(
    (insta: any) => insta["instagram"] && Object.keys(insta)?.length === 1
  );
  const instaPagesCount = instaPages.length;
  const bothPages = pagesData.filter(
    (fbi: any) => Object.keys(fbi)?.length > 1
  );
  const bothPagesCount = bothPages.length;

  return (
    <div className="account-pages container-login100 mt-0.5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 text-center mb-2">
            <img src="../assets/images/Logo.png" alt="" />
          </div>
        </div>
        <div className="row justify-content-center mb-4 manage">
          <div className="col-md-12 col-lg-8 col-xl-6">
            <div className="manage-page">
              <nav>
                <div
                  className="nav nav-tabs justify-content-center"
                  id="nav-tab"
                  role="tablist">
                  <button
                    className={`nav-item nav-link ${
                      selectedTab === "nav-fbinsta-tab" ? "active" : ""
                    }`}
                    id="nav-fbinsta-tab"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected="true"
                    onClick={ontabChange}>
                    {" "}
                    <FacebookIcon color="primary" />
                    Facebook &
                    <InstagramIcon color="secondary" />
                    Insta
                  </button>
                  &nbsp;&nbsp;&nbsp;
                  <button
                    className={`nav-item nav-link ${
                      selectedTab === "nav-fb-tab" ? "active" : ""
                    }`}
                    id="nav-fb-tab"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected="true"
                    onClick={ontabChange}>
                    {" "}
                    <FacebookIcon color="primary" />
                    Facebook
                  </button>
                  &nbsp;&nbsp;&nbsp;
                  <button
                    className={`nav-item nav-link ${
                      selectedTab === "nav-inst-tab" ? "active" : ""
                    }`}
                    id="nav-inst-tab"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    onClick={ontabChange}>
                    <InstagramIcon color="secondary" />
                    Instagram
                  </button>
                </div>
              </nav>{" "}
              {selectedTab === "nav-fb-tab" ? (
                <div id="nav-fb-tab">
                  <FacebookAccess data={fbPages} count={fbPagesCount} />
                </div>
              ) : (
                ""
              )}
              {selectedTab === "nav-inst-tab" ? (
                <div id="nav-inst-tab">
                  <InstagramAccess data={instaPages} count={instaPagesCount} />
                </div>
              ) : (
                ""
              )}
              {""}
              {selectedTab === "nav-fbinsta-tab" ? (
                <div id="nav-fbinsta-tab">
                  <FbAndInstaAccess data={bothPages} count={bothPagesCount} />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExistingFBPages;
